import { useEffect, useState } from "react";
import { CalendarCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { myBriefing, saveMyBriefing } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Switch } from "../ui/switch";
import { SchedulePicker } from "./SchedulePicker";

// Partner view: manage only my own Sunday briefing delivery + language.
export const MyBriefingSettings = ({ open, onOpenChange }) => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) myBriefing().then((r) => setS({ ...r, tz: r.tz === "UTC" ? (Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC") : r.tz })).catch(() => toast.error("Couldn't load your briefing settings")); }, [open]);
  const save = async () => {
    setBusy(true);
    try { const r = await saveMyBriefing({ enabled: s.enabled, email: s.email, phone: s.phone, lang: s.lang, days: s.days, hour: s.hour, tz: s.tz }); setS(r); toast.success(r.enabled ? "Your briefing is on" : "Your briefing is off"); } catch (e) { toast.error(e?.response?.data?.detail || "Couldn't save"); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="my-briefing-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl flex items-center gap-2"><CalendarCheck className="h-5 w-5 text-primary" /> My Sunday briefing</DialogTitle>
          <DialogDescription>Renewals due, overdue items and what was filed — sent on the days and hour you choose, in your language.</DialogDescription>
        </DialogHeader>
        {!s ? <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" /> : (
          <div className="space-y-4 text-sm">
            <label className="flex items-center justify-between gap-3 rounded-xl border border-border px-3 py-2.5"><span>Send me the briefing on my schedule</span><Switch data-testid="my-briefing-toggle" checked={s.enabled} onCheckedChange={(v) => setS({ ...s, enabled: v })} /></label>
            <label className="block text-xs text-muted-foreground">Email<Input data-testid="my-briefing-email" type="email" value={s.email} onChange={(e) => setS({ ...s, email: e.target.value })} placeholder="you@example.com" className="mt-1" /></label>
            <label className="block text-xs text-muted-foreground">Mobile for SMS (optional)<Input data-testid="my-briefing-phone" type="tel" value={s.phone} onChange={(e) => setS({ ...s, phone: e.target.value })} placeholder="+1 555 010 0100" className="mt-1" /></label>
            <SchedulePicker value={{ days: s.days, hour: s.hour, tz: s.tz }} onChange={(v) => setS({ ...s, ...v })} testid="my-briefing" />
            <label className="block text-xs text-muted-foreground">Language
              <select data-testid="my-briefing-lang" value={s.lang} onChange={(e) => setS({ ...s, lang: e.target.value })} className="mt-1 w-full h-10 rounded-md border border-input bg-background px-3 text-sm text-foreground"><option value="en">English</option><option value="es">Español</option></select>
            </label>
            <div className="flex items-center gap-3">
              <Button data-testid="my-briefing-save" size="sm" disabled={busy} onClick={save} className="rounded-full">Save</Button>
              {s.last_sent_at && <span className="text-xs text-muted-foreground">Last sent {new Date(s.last_sent_at).toLocaleDateString()}</span>}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
